// extracted by mini-css-extract-plugin
export default {"wrap":"NotFoundPage_wrap__jRZl7","link":"NotFoundPage_link__iZyh1"};